export enum EnvironmentTermsPlacement {
  LastPage = 'lastPage',
  Footer = 'footer',
  FundSummary = 'fundSummary',
  FundDetail = 'fundDetail',
}
